import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

export function createContactMutations(client: StoxlyClient) {
  return {
    createInquiry: {
      mutationFn: (body: Body<'contactCreateInquiry'>) => client.contactCreateInquiry(body),
    },
  };
}
